import { render, staticRenderFns } from "./DataPrice.vue?vue&type=template&id=53cbb1a5&"
import script from "./DataPrice.vue?vue&type=script&lang=js&"
export * from "./DataPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports